import {branch, renderNothing} from 'recompose'

import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import withHook from '../../../../../hocs/withHook'
import useInterval from '../../../../../hooks/useInterval'
import type {State} from '../../../../../reducers/types'
import {getBuild, getExtensionEndpoint} from '../../../../../selectors'
import {fetchBuildLogMessages, fetchBuildLogPreview} from '../../BuildLog.actions'
import {getBuildLogMessages} from '../../BuildLog.selectors'
import {getKeyForBuildLogData} from '../../BuildLog.utils'

import BuildLogRunningMessages, {MESSAGES_COUNT} from './BuildLogRunningMessages'
import type {OwnProps, StateProps, ActionCreators, Props} from './BuildLogRunningMessages.types'

const UPDATE_INTERVAL = 5000

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const {buildId} = props
  const build = getBuild(state, buildId)
  const running = build?.state === 'running'
  const buildLogKey = getKeyForBuildLogData({
    type: 'preview',
    id: buildId,
  })
  const extensionEnabled = Boolean(getExtensionEndpoint(state, 'fetchExpandedBuildLogMessage'))
  const {data, ready} = (extensionEnabled ? getBuildLogMessages(state, buildLogKey) : null) ?? {
    data: null,
    ready: false,
  }
  return {
    messages: data,
    extensionEnabled,
    running,
    ready,
  }
}

const actionCreators: ActionCreators = {
  fetchBuildLogPreview,
  fetchBuildLogMessages,
}
export default compose(
  connect(mapStateToProps, actionCreators),
  branch(({extensionEnabled, running}: Props) => !extensionEnabled || !running, renderNothing),
  withHook(({buildId, fetchBuildLogPreview: fetch, running}: Props) => {
    useInterval(() => fetch(buildId, MESSAGES_COUNT), running ? UPDATE_INTERVAL : null, true)
  }),
)(BuildLogRunningMessages)
